<script setup lang="ts">
import { type IAuthor } from "~/types/IAuthor";
import AuthorCard from "~/components/AuthorCard.vue";

export interface IOverviewAuthorListProps {
  topicEditorsOrCoordinators: IAuthor[];
  topicTitle: string;
}

const props = defineProps<IOverviewAuthorListProps>();

const terminology = useTerminologyStore();
</script>
<template>
  <section :id="`topic-${topicTitle}`">
    <h2>{{ terminology.getTerm("topicTitle") }} {{ topicTitle }}</h2>
    <ul class="Overview__authorsCards">
      <li
        v-for="author in props.topicEditorsOrCoordinators"
        :key="author.userId">
        <AuthorCard v-bind="author" />
      </li>
    </ul>
  </section>
</template>
